


















// tslint:disable-next-line:no-unused
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';

const cssPrefix = 'custom-dropdown-rows';

@Component({
  components: {
    CustomDropdownRows,
  },
})
export default class CustomDropdownRows extends SwExtendedVue {
  @Prop({ type: String, default: '' })
  selectedOption: string;

  cssPrefix = cssPrefix;

  optionSelected() {
    if (this.selectedOption !== 'No results to display') {
      this.$emit('optionSelected', this.selectedOption);
    }
  }
}
